export const PHONE_HREF = 'tel:+78463782525';
export const PHONE_DISPLAY = '8 (846) 3782525';
export const SALES_PHONE_LABEL = 'Отдел продаж';
export const SALES_PHONE_DISPLAY = '8 (904) 7083226';
export const SALES_PHONE_HREF = 'tel:+79047083226';
export const EMAIL = 'vdpo@samvdpo.ru';
export const EMAIL_HREF = `mailto:${EMAIL}`;
export const STRELETS_EMAIL = 'sm63@samvdpo.ru';
export const STRELETS_EMAIL_HREF = `mailto:${STRELETS_EMAIL}`;

export const PRIMARY_ADDRESS =
  '443099, Самарская область, г. о. Самара, г. Самара, ул. Молодогвардейская, д. 33, помещ. АА1-А5, А9, А12, З, Г, В.';

export const SECONDARY_ADDRESS =
  '443100, Самарская область, г. Самара, ул. Невская, д. 3, офис 315';

export const ALL_ADDRESSES = [PRIMARY_ADDRESS, SECONDARY_ADDRESS];

export const FOOTER_ADDRESSES = [
  {
    label: 'Основной офис',
    text: 'Самара, ул. Молодогвардейская, 33',
  },
  {
    label: 'Городское отделение',
    text: 'Самара, ул. Невская, 3, оф. 315',
  },
];
